export default [
  // {
  //   name: "BTC",
  //   whitebit: {
  //     out: {
  //       comissionAmount: 0.0006
  //     }
  //   }
  // },
  {
    name: "USDT",
    whitebit: {
      out: {
        comissionAmount: 1
      }
    }
  },
  {
    name: "DOGE",
    whitebit: {
      out: {
        comissionAmount: 10
      }
    }
  },
  {
    name: "LTC",
    whitebit: {
      out: {
        comissionAmount: 0.001
      }
    }
  },
  {
    name: "XMR",
    whitebit: {
      out: {
        comissionAmount: 0.005
      }
    }
  },
  {
    name: "TRX",
    whitebit: {
      out: {
        comissionAmount: 1
      }
    }
  }
  // {
  //   name: "RUB",
  //   vanilapay: {
  //     out: {
  //       comissionAmountPercent: 2
  //     },
  //     in: {
  //       comissionAmountPercent: 2
  //     }
  //   }
  // }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/fees.js